export default "__VITE_ASSET__BsA29uq4__"